// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import Modal from "@insite/mobius/Modal";
import useBuyingList from "@store/Framework/Common/Hooks/useBuyingList/useBuyingList";
import { createBuyingList } from "@store/Framework/Services/RestrictedBuyingListService";
import { CustomWidgetModule } from "@store/Framework/Types/types";
import { ButtonProps } from "@store/MobiusOverrides/Button/Props";
import MyListsEditListForm from "@store/MobiusOverrides/MyLists/MyListsEditListForm";
import ButtonWidget, { OwnProps as ButtonWidgetProps } from "@store/Overrides/Widgets/Basic/Button";
import React from "react";

export interface BuyingListManagementButtonstyles {
    newListButton: ButtonProps;
}
const Button = ButtonWidget.component as React.FC<ButtonWidgetProps>;

const BuyingListManagementCreateNewListButton: React.FC<ButtonWidgetProps> = widgetProps => {
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const { getBuyingLists, loading } = useBuyingList();
    const handleSubmit = () => {
        setIsModalOpen(false);
        getBuyingLists(true);
    };
    return (
        <>
            <Button
                {...widgetProps}
                buttonProps={{
                    disabled: loading,
                    onClick: () => setIsModalOpen(true),
                    "data-test-selector": "buyingListManagementCreate_newListButton",
                }}
            >
                {translate("Create List")}
            </Button>
            <Modal
                headline={translate("Create List")}
                sizeVariant="small"
                isOpen={isModalOpen}
                handleClose={() => setIsModalOpen(false)}
                data-test-selector="buyingListManagementCreate_modal"
            >
                <MyListsEditListForm
                    onCancel={() => setIsModalOpen(false)}
                    onSubmit={handleSubmit}
                    createBuyingList={createBuyingList}
                    data-test-selector="buyingListManagementCreate_editForm"
                ></MyListsEditListForm>
            </Modal>
        </>
    );
};

const widgetModule: CustomWidgetModule = {
    component: BuyingListManagementCreateNewListButton,
    definition: {
        group: "Buying List",
        fieldDefinitions: ButtonWidget.definition.fieldDefinitions,
    },
};

export default widgetModule;
